import { FC, useMemo, useState } from 'react'

import { Bid, BidTypes } from 'modules/domain/bid/types'
import { endpoints } from 'modules/endpoints'
import AComments from 'views/components/Comments/AComments'
import { CommentType } from 'modules/domain/comment/types'
import { useTranslation } from 'react-i18next'
import { AntCollapse, Panel } from '@agro-club/agroclub-shared'
import AntCollapseHeader from 'views/components/AntCollapseHeader/AntCollapseHeader'
import { SummaryComments } from 'views/components/AntCollapseHeader/SummaryComments'
import { SummaryThereIsNo } from 'views/components/AntCollapseHeader/SummaryThereIsNo'
import { HistoryTable } from './History/HistoryTable'
import { BidSamples } from 'views/components/Sample/SampleRequest/BidSamples'
import { SampleWithRequests } from 'views/pages/Samples/types'

type Props = {
  bid: Bid
  samples: SampleWithRequests[]
  samplesRefetch: (silent?: boolean) => Promise<void>
}

export const BidRightBlock: FC<Props> = ({ bid, samples, samplesRefetch }) => {
  const { t } = useTranslation('bid')

  const [commentsSummary, setCommentsSummary] = useState<string>('')
  const [samplesSummary, setSamplesSummary] = useState<number>()

  const options = useMemo<{ title: string; value: string; isOpened?: boolean; isShow?: boolean }[]>(
    () =>
      [
        { value: 'comments', title: t('form.userComment'), isOpened: true, isShow: true },
        { value: 'samples', title: t('form.samples'), isOpened: true, isShow: bid.bid_type !== BidTypes.purchase },
        { value: 'history', title: t('form.history'), isOpened: true, isShow: true },
      ].filter((option) => option.isShow),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t],
  )

  const [activeKey, setActiveKey] = useState<string | string[]>(options[0].value)
  const components = {
    comments: (
      <AComments
        id={bid?.owner?.id}
        type={CommentType.user}
        url={endpoints.userComments(bid?.owner?.id)}
        maxHeight={400}
        popSummary={setCommentsSummary}
      />
    ),
    samples: <BidSamples bid={bid} setSummary={setSamplesSummary} samples={samples} samplesRefetch={samplesRefetch} />,
    history: <HistoryTable />,
  }
  const summary = {
    comments: <SummaryComments summary={commentsSummary} />,
    samples: <SummaryThereIsNo hasData={samplesSummary} />,
  }
  return (
    <AntCollapse accordion bordered={false} defaultActiveKey={options[0].value} onChange={(key) => setActiveKey(key)}>
      {options.map((option) => (
        <Panel
          forceRender
          header={
            <AntCollapseHeader title={option.title} summary={activeKey !== option.value && summary[option.value]} />
          }
          key={option.value}
        >
          {components[option.value]}
        </Panel>
      ))}
    </AntCollapse>
  )
}
